const oudi = `A voice only social media application created using Swift and Google Firebase for iOS. It allows users to easily interact with with each other while recording voice notes and attaching visual media. All data on the application is then managed using Firebase Realtime Database.`;

export default oudi;
